module.exports = __webpack_public_path__ + "img/arrow.017cb8e.png";